/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-unsafe-call */

import { Question } from '@/types'

/* eslint-disable @typescript-eslint/no-unsafe-member-access */
const elationOptions = {
  'Patient Demographics': [
    { value: 'patients.first_name', label: 'Legal First Name' },
    { value: 'patients.middle_name', label: 'Middle Name' },
    { value: 'patients.last_name', label: 'Legal Last Name' },
    { value: 'patients.sex', label: 'Sex at Birth*' },
    { value: 'patients.actual_name', label: 'Preferred Name' },
    { value: 'patients.pronouns', label: 'Pronouns*' },
    { value: 'patients.gender_identity', label: 'Gender*' },
    { value: 'patients.sexual_orientation', label: 'Sexual Orientation*' },
    { value: 'patients.primary_physician', label: 'Physician in Practice*' },
    { value: 'patients.dob', label: 'Date of Birth' },
    { value: 'patients.ssn', label: 'SSN' },
    { value: 'patients.race', label: 'Race*' },
    { value: 'patients.preferred_language', label: 'Preferred Language' },
    { value: 'patients.ethnicity', label: 'Ethnicity*' },
    { value: 'patient_photo', label: 'Profile Picture' },
    { value: 'patients.notes', label: 'Notes' },
    { value: 'patients.address.address_line1', label: 'Address' },
    { value: 'patients.address.address_line2', label: 'Address Line 2' },
    { value: 'patients.address.city', label: 'City' },
    { value: 'patients.address.state', label: 'State*' },
    { value: 'patients.address.zip', label: 'Zip' },
    {
      value: 'patients.phones.phone|phone_type=Mobile',
      label: 'Mobile Phone',
    },
    { value: 'patients.phones.phone|phone_type=Home', label: 'Home Phone' },
    { value: 'patients.phones.phone|phone_type=Main', label: 'Main Phone' },
    { value: 'patients.phones.phone|phone_type=Work', label: 'Work Phone' },
    {
      value: 'patients.phones.phone|phone_type=Night',
      label: 'Night Phone',
    },
    { value: 'patients.phones.phone|phone_type=Fax', label: 'Fax Phone' },
    {
      value: 'patients.phones.phone|phone_type=Other',
      label: 'Other Phone',
    },
    { value: 'patients.emails.email', label: 'Email' },
    { value: 'patients.preferred_contact', label: 'Preferred Contact Method*' },
    { value: 'patients.tags', label: 'Tags' },
    { value: 'patients.patient_status.status', label: 'Patient Status*' },
  ],
  Guarantor: [
    { value: 'patients.guarantor.first_name', label: 'First Name' },
    { value: 'patients.guarantor.last_name', label: 'Last Name' },
    { value: 'patients.guarantor.address', label: 'Address' },
    { value: 'patients.guarantor.city', label: 'City' },
    { value: 'patients.guarantor.state', label: 'State*' },
    { value: 'patients.guarantor.zip', label: 'Zip' },
    { value: 'patients.guarantor.phone', label: 'Phone' },
    { value: 'patients.guarantor.relationship', label: 'Relationship*' },
  ],
  'Primary Insurance': [
    {
      value: 'patients.insurances.carrier|rank=primary',
      label: 'Insurance Carrier Name',
    },
    {
      value: 'patients.insurances.member_id|rank=primary',
      label: 'Member ID',
    },
    {
      value: 'patients.insurances.group_id|rank=primary',
      label: 'Group ID',
    },
    {
      value: 'patients.insurances.payment_program|rank=primary',
      label: 'Coverage',
    },
    { value: 'patients.insurances.plan|rank=primary', label: 'Plan Name' },
    {
      value: 'insurance_cards.primary.front',
      label: 'Insurance Card Front',
    },
    { value: 'insurance_cards.primary.back', label: 'Insurance Card Back' },
    { value: 'patients.insurances.address|rank=primary', label: 'Address' },
    { value: 'patients.insurances.suite|rank=primary', label: 'Suite' },
    { value: 'patients.insurances.city|rank=primary', label: 'City' },
    { value: 'patients.insurances.state|rank=primary', label: 'State*' },
    { value: 'patients.insurances.zip|rank=primary', label: 'Zip' },
  ],
  'Primary Insurance Policy Holder': [
    {
      value: 'patients.insurances.insured_person_first_name|rank=primary',
      label: 'First Name',
    },
    {
      value: 'patients.insurances.insured_person_last_name|rank=primary',
      label: 'Last Name',
    },
    {
      value: 'patients.insurances.insured_person_address|rank=primary',
      label: 'Address',
    },
    {
      value: 'patients.insurances.insured_person_city|rank=primary',
      label: 'City',
    },
    {
      value: 'patients.insurances.insured_person_state|rank=primary',
      label: 'State*',
    },
    {
      value: 'patients.insurances.insured_person_zip|rank=primary',
      label: 'Zip',
    },
    {
      value: 'patients.insurances.insured_person_dob|rank=primary',
      label: 'Date of Birth',
    },
    {
      value: 'patients.insurances.insured_person_gender|rank=primary',
      label: 'Sex at Birth*',
    },
    {
      value: 'patients.insurances.insured_person_ssn|rank=primary',
      label: 'SSN',
    },
    {
      value: 'patients.insurances.relationship_to_insured|rank=primary',
      label: 'Patient Relation to Policyholder*',
    },
    {
      value: 'patients.insurances.insured_person_id|rank=primary',
      label: 'Insured Person ID',
    },
  ],
  'Secondary Insurance': [
    {
      value: 'patients.insurances.carrier|rank=secondary',
      label: 'Insurance Carrier Name',
    },
    {
      value: 'patients.insurances.member_id|rank=secondary',
      label: 'Member ID',
    },
    {
      value: 'patients.insurances.group_id|rank=secondary',
      label: 'Group ID',
    },
    {
      value: 'patients.insurances.payment_program|rank=secondary',
      label: 'Coverage',
    },
    { value: 'patients.insurances.plan|rank=secondary', label: 'Plan Name' },
    {
      value: 'insurance_cards.secondary.front',
      label: 'Insurance Card Front',
    },
    {
      value: 'insurance_cards.secondary.back',
      label: 'Insurance Card Back',
    },
    {
      value: 'patients.insurances.address|rank=secondary',
      label: 'Address',
    },
    {
      value: 'patients.insurances.suite|rank=secondary',
      label: 'Suite',
    },
    { value: 'patients.insurances.city|rank=secondary', label: 'City' },
    { value: 'patients.insurances.state|rank=secondary', label: 'State*' },
    { value: 'patients.insurances.zip|rank=secondary', label: 'Zip' },
  ],
  'Secondary Insurance Policy Holder': [
    {
      value: 'patients.insurances.insured_person_first_name|rank=secondary',
      label: 'First Name',
    },
    {
      value: 'patients.insurances.insured_person_last_name|rank=secondary',
      label: 'Last Name',
    },
    {
      value: 'patients.insurances.insured_person_address|rank=secondary',
      label: 'Address',
    },
    {
      value: 'patients.insurances.insured_person_city|rank=secondary',
      label: 'City',
    },
    {
      value: 'patients.insurances.insured_person_state|rank=secondary',
      label: 'State*',
    },
    {
      value: 'patients.insurances.insured_person_zip|rank=secondary',
      label: 'Zip',
    },
    {
      value: 'patients.insurances.insured_person_dob|rank=secondary',
      label: 'Date of Birth',
    },
    {
      value: 'patients.insurances.insured_person_gender|rank=secondary',
      label: 'Sex at Birth*',
    },
    {
      value: 'patients.insurances.insured_person_ssn|rank=secondary',
      label: 'SSN',
    },
    {
      value: 'patients.insurances.relationship_to_insured|rank=secondary',
      label: 'Patient Relation to Policyholder*',
    },
    {
      value: 'patients.insurances.insured_person_id|rank=secondary',
      label: 'Insured Person ID',
    },
  ],
  'Emergency Contact': [
    {
      value: 'patients.emergency_contact.first_name',
      label: 'First Name',
    },
    { value: 'patients.emergency_contact.last_name', label: 'Last Name' },
    {
      value: 'patients.emergency_contact.relationship',
      label: 'Relationship*',
    },
    { value: 'patients.emergency_contact.phone', label: 'Phone ' },
    { value: 'patients.emergency_contact.address_line1', label: 'Address' },
    {
      value: 'patients.emergency_contact.address_line2',
      label: 'Address Line 2',
    },
    { value: 'patients.emergency_contact.city', label: 'City' },
    { value: 'patients.emergency_contact.state', label: 'State*' },
    { value: 'patients.emergency_contact.zip', label: 'Zip' },
  ],
  'History (clinical profile)': [
    { value: 'histories.text|type=Past', label: 'PMH' },
    { value: 'histories.text|type=Family', label: 'FH' },
    { value: 'histories.text|type=Social', label: 'SH' },
    { value: 'histories.text|type=Habits', label: 'Habits' },
    { value: 'histories.text|type=Diet', label: 'Diet' },
    { value: 'histories.text|type=Exercise', label: 'Exercise' },
    { value: 'histories.text|type=Immunization', label: 'Vacc' },
    { value: 'histories.text|type=Legal', label: 'Legal' },
    { value: 'histories.text|type=Consultation', label: 'Spec' },
    {
      value: 'histories.text|type=Health Maintenance',
      label: 'Health Maintenance',
    },
    { value: 'histories.text|type=Past Surgical', label: 'PSH' },
    { value: 'histories.text|type=Cognitive Status', label: 'Cogn' },
    { value: 'histories.text|type=Functional Status', label: 'Func' },
    { value: 'histories.text|type=Psychological', label: 'Psych' },
    {
      value: 'family_histories.text|relationship=Mother',
      label: 'FH: Mother',
    },
    {
      value: 'family_histories.text|relationship=Father',
      label: 'FH: Father',
    },
    {
      value: 'family_histories.text|relationship=Brother',
      label: 'FH: Brother',
    },
    {
      value: 'family_histories.text|relationship=Sister',
      label: 'FH: Sister',
    },
    { value: 'family_histories.text|relationship=Son', label: 'FH: Son' },
    {
      value: 'family_histories.text|relationship=Daughter',
      label: 'FH: Daughter',
    },
    {
      value: 'family_histories.text|relationship=Grandmother',
      label: 'FH: Grandmother',
    },
    {
      value: 'family_histories.text|relationship=Grandfather',
      label: 'FH: Grandfather',
    },
    { value: 'family_histories.text|relationship=Aunt', label: 'FH: Aunt' },
    {
      value: 'family_histories.text|relationship=Uncle',
      label: 'FH: Uncle',
    },
    {
      value: 'family_histories.text|relationship=Other',
      label: 'FH: Other',
    },
    { value: 'allergies.reaction', label: 'Allergy Reaction' },
    { value: 'allergies.name', label: 'Allergy Name' },
    { value: 'allergies.name&reaction', label: 'Allergy Name & Reaction' },
    { value: 'problems.dx.snomed', label: 'Problem: SNOMED' },
  ],
  Notes: [
    { value: 'non_visit_notes-nonvisit.bullets.text', label: 'Non-Visit Note' },
    { value: 'non_visit_notes-email.bullets.text', label: 'Email Note' },
    { value: 'non_visit_notes-phone.bullets.text', label: 'Phone Note' },
  ],
  'Simple Visit Note': [
    {
      value: 'visit_notes-Simple.bullets.text|category=Reason',
      label: 'Exam Reason',
    },
    {
      value: 'visit_notes-Simple.bullets.text|category=Narrative',
      label: 'HPI Narrative',
    },
    {
      value: 'visit_notes-Simple.bullets.text|category=Followup',
      label: 'Followup',
    },
    { value: 'visit_notes-Simple.vitals.height#value', label: 'Ht' },
    { value: 'visit_notes-Simple.vitals.weight#value', label: 'Wt' },
    { value: 'visit_notes-Simple.vitals.oxygen#value', label: 'O2' },
    { value: 'visit_notes-Simple.vitals.rr#value', label: 'RR' },
    { value: 'visit_notes-Simple.vitals.hr#value', label: 'HR' },
    { value: 'visit_notes-Simple.vitals.hc#value', label: 'HC' },
    { value: 'visit_notes-Simple.vitals.temperature#value', label: 'Temp' },
    { value: 'visit_notes-Simple.vitals.bp#systolic', label: 'BP Sys' },
    { value: 'visit_notes-Simple.vitals.bp#diastolic', label: 'BP Dia' },
    { value: 'visit_notes-Simple.vitals.pain#value', label: 'Pain' },
  ],
  'SOAP Notes': [
    {
      value: 'visit_notes-SOAP.bullets.text|category=Reason',
      label: 'Exam Reason',
    },
    {
      value: 'visit_notes-SOAP.bullets.text|category=Problem',
      label: 'Problem/HPI',
    },
    {
      value: 'visit_notes-SOAP.bullets.text|category=Objective',
      label: 'Objective',
    },
    {
      value: 'visit_notes-SOAP.bullets.text|category=Assessment',
      label: 'Assessment',
    },
    { value: 'visit_notes-SOAP.bullets.text|category=Plan', label: 'Plan' },
    {
      value: 'visit_notes-SOAP.bullets.text|category=Followup',
      label: 'Followup',
    },
    { value: 'visit_notes-SOAP.bullets.text|category=ROS', label: 'ROS' },
    { value: 'visit_notes-SOAP.vitals.height#value', label: 'Ht' },
    { value: 'visit_notes-SOAP.vitals.weight#value', label: 'Wt' },
    { value: 'visit_notes-SOAP.vitals.oxygen#value', label: 'O2' },
    { value: 'visit_notes-SOAP.vitals.rr#value', label: 'RR' },
    { value: 'visit_notes-SOAP.vitals.hr#value', label: 'HR' },
    { value: 'visit_notes-SOAP.vitals.hc#value', label: 'HC' },
    { value: 'visit_notes-SOAP.vitals.temperature#value', label: 'Temp' },
    { value: 'visit_notes-SOAP.vitals.bp#systolic', label: 'BP Sys' },
    { value: 'visit_notes-SOAP.vitals.bp#diastolic', label: 'BP Dia' },
    { value: 'visit_notes-SOAP.vitals.pain#value', label: 'Pain' },
  ],
  'Complete H&P Note (1 col)': [
    {
      value: 'visit_notes-H&P_1col.bullets.text|category=Hpi',
      label: 'HPI Narrative',
    },
    {
      value: 'visit_notes-H&P_1col.bullets.text|category=Allergies',
      label: 'Allergies',
    },
    {
      value: 'visit_notes-H&P_1col.bullets.text|category=Past',
      label: 'PMH',
    },
    {
      value: 'visit_notes-H&P_1col.bullets.text|category=Surgical',
      label: 'PSH',
    },
    {
      value: 'visit_notes-H&P_1col.bullets.text|category=Family',
      label: 'FH',
    },
    {
      value: 'visit_notes-H&P_1col.bullets.text|category=Social',
      label: 'SH',
    },
    {
      value: 'visit_notes-H&P_1col.bullets.text|category=Habits',
      label: 'Habits',
    },
    {
      value: 'visit_notes-H&P_1col.bullets.text|category=Med',
      label: 'Current Medications',
    },
    {
      value: 'visit_notes-H&P_1col.bullets.text|category=ROS',
      label: 'ROS',
    },
    {
      value: 'visit_notes-H&P_1col.bullets.text|category=Reason',
      label: 'Exam Reason',
    },
    {
      value: 'visit_notes-H&P_1col.bullets.text|category=Assessplan',
      label: 'Assess/plan',
    },
    {
      value: 'visit_notes-H&P_1col.bullets.text|category=Data',
      label: 'Data',
    },
    { value: 'visit_notes-H&P_1col.vitals.height#value', label: 'Ht' },
    { value: 'visit_notes-H&P_1col.vitals.weight#value', label: 'Wt' },
    { value: 'visit_notes-H&P_1col.vitals.oxygen#value', label: 'O2' },
    { value: 'visit_notes-H&P_1col.vitals.rr#value', label: 'RR' },
    { value: 'visit_notes-H&P_1col.vitals.hr#value', label: 'HR' },
    { value: 'visit_notes-H&P_1col.vitals.hc#value', label: 'HC' },
    { value: 'visit_notes-H&P_1col.vitals.temperature#value', label: 'Temp' },
    { value: 'visit_notes-H&P_1col.vitals.bp#systolic', label: 'BP Sys' },
    { value: 'visit_notes-H&P_1col.vitals.bp#diastolic', label: 'BP Dia' },
    { value: 'visit_notes-H&P_1col.vitals.pain#value', label: 'Pain' },
  ],
  'Complete H&P Note (2 col)': [
    {
      value: 'visit_notes-H&P_2col.bullets.text|category=Problem',
      label: 'Problem/HPI',
    },
    {
      value: 'visit_notes-H&P_2col.bullets.text|category=Allergies',
      label: 'Allergies',
    },
    {
      value: 'visit_notes-H&P_2col.bullets.text|category=Past',
      label: 'PMH',
    },
    {
      value: 'visit_notes-H&P_2col.bullets.text|category=Surgical',
      label: 'PSH',
    },
    {
      value: 'visit_notes-H&P_2col.bullets.text|category=Family',
      label: 'FH',
    },
    {
      value: 'visit_notes-H&P_2col.bullets.text|category=Social',
      label: 'SH',
    },
    {
      value: 'visit_notes-H&P_2col.bullets.text|category=Habits',
      label: 'Habits',
    },
    {
      value: 'visit_notes-H&P_2col.bullets.text|category=Med',
      label: 'Current Medications',
    },
    {
      value: 'visit_notes-H&P_2col.bullets.text|category=Reason',
      label: 'Exam Reason',
    },
    {
      value: 'visit_notes-H&P_2col.bullets.text|category=ROS',
      label: 'ROS',
    },
    {
      value: 'visit_notes-H&P_2col.bullets.text|category=Assessment',
      label: 'Assessment',
    },
    {
      value: 'visit_notes-H&P_2col.bullets.text|category=Data',
      label: 'Data',
    },
    { value: 'visit_notes-H&P_2col.vitals.height#value', label: 'Ht' },
    { value: 'visit_notes-H&P_2col.vitals.weight#value', label: 'Wt' },
    { value: 'visit_notes-H&P_2col.vitals.oxygen#value', label: 'O2' },
    { value: 'visit_notes-H&P_2col.vitals.rr#value', label: 'RR' },
    { value: 'visit_notes-H&P_2col.vitals.hr#value', label: 'HR' },
    { value: 'visit_notes-H&P_2col.vitals.hc#value', label: 'HC' },
    { value: 'visit_notes-H&P_2col.vitals.temperature#value', label: 'Temp' },
    { value: 'visit_notes-H&P_2col.vitals.bp#systolic', label: 'BP Sys' },
    { value: 'visit_notes-H&P_2col.vitals.bp#diastolic', label: 'BP Dia' },
    { value: 'visit_notes-H&P_2col.vitals.pain#value', label: 'Pain' },
  ],
  'Complete H&P Note (2 col A/P)': [
    {
      value: 'visit_notes-H&P_2col_AP.bullets.text|category=Problem',
      label: 'Problem/HPI',
    },
    {
      value: 'visit_notes-H&P_2col_AP.bullets.text|category=Allergies',
      label: 'Allergies',
    },
    {
      value: 'visit_notes-H&P_2col_AP.bullets.text|category=Past',
      label: 'PMH',
    },
    {
      value: 'visit_notes-H&P_2col_AP.bullets.text|category=Surgical',
      label: 'PSH',
    },
    {
      value: 'visit_notes-H&P_2col_AP.bullets.text|category=Family',
      label: 'FH',
    },
    {
      value: 'visit_notes-H&P_2col_AP.bullets.text|category=Social',
      label: 'SH',
    },
    {
      value: 'visit_notes-H&P_2col_AP.bullets.text|category=Habits',
      label: 'Habits',
    },
    {
      value: 'visit_notes-H&P_2col_AP.bullets.text|category=Med',
      label: 'Current Medications',
    },
    {
      value: 'visit_notes-H&P_2col_AP.bullets.text|category=Reason',
      label: 'Exam Reason',
    },
    {
      value: 'visit_notes-H&P_2col_AP.bullets.text|category=ROS',
      label: 'ROS',
    },
    {
      value: 'visit_notes-H&P_2col_AP.bullets.text|category=Assessplan',
      label: 'Assess/plan',
    },
    {
      value: 'visit_notes-H&P_2col_AP.bullets.text|category=Data',
      label: 'Data',
    },
    { value: 'visit_notes-H&P_2col_AP.vitals.height#value', label: 'Ht' },
    { value: 'visit_notes-H&P_2col_AP.vitals.weight#value', label: 'Wt' },
    { value: 'visit_notes-H&P_2col_AP.vitals.oxygen#value', label: 'O2' },
    { value: 'visit_notes-H&P_2col_AP.vitals.rr#value', label: 'RR' },
    { value: 'visit_notes-H&P_2col_AP.vitals.hr#value', label: 'HR' },
    { value: 'visit_notes-H&P_2col_AP.vitals.hc#value', label: 'HC' },
    {
      value: 'visit_notes-H&P_2col_AP.vitals.temperature#value',
      label: 'Temp',
    },
    { value: 'visit_notes-H&P_2col_AP.vitals.bp#systolic', label: 'BP Sys' },
    { value: 'visit_notes-H&P_2col_AP.vitals.bp#diastolic', label: 'BP Dia' },
    { value: 'visit_notes-H&P_2col_AP.vitals.pain#value', label: 'Pain' },
  ],
  Reports: [
    { value: 'reports.document|type=Allergist', label: 'Allergist' },
    { value: 'reports.document|type=Audiology', label: 'Audiology' },
    { value: 'reports.document|type=Billing', label: 'Billing' },
    { value: 'reports.document|type=Business', label: 'Business' },
    { value: 'reports.document|type=Cardiac', label: 'Cardiac' },
    { value: 'reports.document|type=CarePlan', label: 'CarePlan' },
    { value: 'reports.document|type=Consent', label: 'Consent' },
    { value: 'reports.document|type=Consultation', label: 'Consultation' },
    { value: 'reports.document|type=Correspondence', label: 'Correspondence' },
    { value: 'reports.document|type=Cosmetic', label: 'Cosmetic' },
    { value: 'reports.document|type=Diabetes', label: 'Diabetes' },
    { value: 'reports.document|type=Directives', label: 'Directives' },
    { value: 'reports.document|type=DME', label: 'DME' },
    { value: 'reports.document|type=EKG', label: 'EKG' },
    { value: 'reports.document|type=Endocrinology', label: 'Endocrinology' },
    { value: 'reports.document|type=ENT', label: 'ENT' },
    { value: 'reports.document|type=Exams', label: 'Exams' },
    { value: 'reports.document|type=EyeVision', label: 'EyeVision' },
    { value: 'reports.document|type=Forms', label: 'Clinical Forms' },
    { value: 'reports.document|type=PatientForm', label: 'Patient Forms' },
    { value: 'reports.document|type=GI', label: 'GI' },
    { value: 'reports.document|type=History', label: 'History' },
    { value: 'reports.document|type=Home', label: 'Home' },
    { value: 'reports.document|type=Hospice', label: 'Hospice' },
    { value: 'reports.document|type=Hospital', label: 'Hospital' },
    { value: 'reports.document|type=Imaging', label: 'Imaging' },
    { value: 'reports.document|type=Incoming', label: 'Incoming' },
    { value: 'reports.document|type=Injection', label: 'Injection' },
    { value: 'reports.document|type=Insurance', label: 'Insurance' },
    { value: 'reports.document|type=Intake', label: 'Intake' },
    { value: 'reports.document|type=Lab', label: 'Lab' },
    { value: 'reports.document|type=Legal', label: 'Legal' },
    { value: 'reports.document|type=Misc', label: 'Misc' },
    { value: 'reports.document|type=Neuro', label: 'Neuro' },
    { value: 'reports.document|type=Nursing', label: 'Nursing' },
    { value: 'reports.document|type=OBGYN', label: 'OBGYN' },
    { value: 'reports.document|type=OldRecord', label: 'OldRecord' },
    { value: 'reports.document|type=Oncology', label: 'Oncology' },
    { value: 'reports.document|type=Ophth', label: 'Ophth' },
    { value: 'reports.document|type=Ortho', label: 'Ortho' },
    { value: 'reports.document|type=OT', label: 'OT' },
    { value: 'reports.document|type=Outgoing', label: 'Outgoing' },
    { value: 'reports.document|type=PaperRx', label: 'PaperRx' },
    { value: 'reports.document|type=Pathology', label: 'Pathology' },
    { value: 'reports.document|type=Pediatric', label: 'Pediatric' },
    { value: 'reports.document|type=Pharmacy', label: 'Pharmacy' },
    { value: 'reports.document|type=Preop', label: 'Preop' },
    { value: 'reports.document|type=PriorAuth', label: 'PriorAuth' },
    { value: 'reports.document|type=Procedures', label: 'Procedures' },
    { value: 'reports.document|type=Psych', label: 'Psych' },
    { value: 'reports.document|type=PT', label: 'PT' },
    { value: 'reports.document|type=Pulmonary', label: 'Pulmonary' },
    { value: 'reports.document|type=Quality', label: 'Quality' },
    { value: 'reports.document|type=Radiology', label: 'Radiology' },
    { value: 'reports.document|type=Screening', label: 'Screening' },
    { value: 'reports.document|type=Sleep', label: 'Sleep' },
    { value: 'reports.document|type=SNF', label: 'SNF' },
    { value: 'reports.document|type=Surgery', label: 'Surgery' },
    { value: 'reports.document|type=Testing', label: 'Testing' },
    { value: 'reports.document|type=Therapy', label: 'Therapy' },
    { value: 'reports.document|type=Ultrasound', label: 'Ultrasound' },
    { value: 'reports.document|type=UrgentCare', label: 'UrgentCare' },
    { value: 'reports.document|type=Urology', label: 'Urology' },
    { value: 'reports.document|type=Women', label: 'Women' },
  ],
  'Fax Inbox': [{ value: 'incoming_files', label: 'Incoming Files (non fax)' }],
}

export const conditionalElationOptionsValue = (
  question: Question | undefined,
  key: string,
  includeFullName = false
) => {
  if (
    key === 'Patient Demographics' &&
    (question?.question_type?.question_subtype === 'full_name' ||
      includeFullName)
  ) {
    // Replace patients.(first|middle|last)_name with patients.full_name
    // @ts-ignore
    let options: { value: string; label: string }[] = elationOptions[key].map(
      (e: { value: string; label: string }) => {
        if (e.value === 'patients.first_name') {
          return {
            label: 'Full Name',
            value: 'patients.full_name#first_name:middle_name:last_name',
          }
        }

        return e
      }
    )
    options = options.filter(
      (e) =>
        e.value !== 'patients.middle_name' && e.value !== 'patients.last_name'
    )

    // Replace patients.guarantor.(first|middle|last)_name with patients.guarantor.full_name
    options = options.map((e) => {
      if (e.value === 'patients.guarantor.first_name') {
        return {
          label: 'Full Name',
          value:
            'patients.guarantor.full_name#first_name:middle_name:last_name',
        }
      }

      return e
    })
    options = options.filter(
      (e) =>
        e.value !== 'patients.guarantor.middle_name' &&
        e.value !== 'patients.guarantor.last_name'
    )

    // Replace patients.emergency_contact.(first|middle|last)_name with patients.emergency_contact.full_name
    options = options.map((e) => {
      if (e.value === 'patients.emergency_contact.first_name') {
        return {
          label: 'Full Name',
          value:
            'patients.emergency_contact.full_name#first_name:middle_name:last_name',
        }
      }

      return e
    })
    options = options.filter(
      (e) =>
        e.value !== 'patients.emergency_contact.middle_name' &&
        e.value !== 'patients.emergency_contact.last_name'
    )

    return options
  }

  if (key === 'History (clinical profile)' && !!question) {
    // Remove allergies.name&reaction if question if not table open_ended
    if (
      question?.question_type?.question_type !== 'table' ||
      question?.question_type?.question_subtype !== 'open_ended'
    ) {
      return elationOptions[key].filter(
        (e: any) => e.value !== 'allergies.name&reaction'
      )
    }
  }

  // @ts-ignore
  return elationOptions[key]
}

export default elationOptions
